import React from 'react';
import { useFocusIdx } from '@bay-email/editor';
import { UseFieldConfig } from 'react-final-form';
import { AutoCheckboxInput } from '../../../components/Form/AutoCheckboxInput';

export function Height({
	config,
	placeholder,
	showPlaceholderWhenAuto,
	allowAuto,
	disabled,
	autoChecked,
	onAutoToggle,
	onValueCommitted,
}: {
	config?: UseFieldConfig<any>;
	placeholder?: string;
	showPlaceholderWhenAuto?: boolean;
	allowAuto?: boolean;
	disabled?: boolean;
	autoChecked?: boolean;
	onAutoToggle?: (_checked: boolean) => void;
	onValueCommitted?: (_value: string | undefined) => void;
}) {
	const { focusIdx } = useFocusIdx();

	return (
		<AutoCheckboxInput
			label='Height (px)'
			name={`${focusIdx}.attributes.height`}
			config={config}
			autoValue='auto'
			placeholder={placeholder}
			showPlaceholderWhenAuto={showPlaceholderWhenAuto}
			allowAuto={allowAuto}
			disabled={disabled}
			autoChecked={autoChecked}
			onAutoToggle={onAutoToggle}
			onValueCommitted={onValueCommitted}
		/>
	);
}
